export const formatVND = (amount) => {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(amount);
};

export const formatVND1000 = (amount) => {
  return formatVND(amount * 1000);
};

export const formatDateTime = (iso) => {
  try {
    if (!iso) return "-";
    const date = new Date(iso);
    return date.toLocaleString("vi-VN", {
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch (e) {
    return iso;
  }
};

export const formatCurrency = (val) => {
  if (!val || isNaN(val)) return "0";
  if (val >= 1_000_000_000) return (val / 1_000_000_000).toFixed(2) + " Tỷ";
  if (val >= 1_000_000) return (val / 1_000_000).toFixed(2) + " Triệu";
  return val.toLocaleString("vi-VN");
};


export const formatNumber = (val) => {
  if (!val || isNaN(val)) return "0";
  if (val >= 1000) return (val / 1000).toFixed(1) + "K";
  return val.toString();
};

export const safeLocaleString = (val) => {
  if (val === undefined || val === null || isNaN(val)) return "0";
  return val.toLocaleString("vi-VN");
};



export const formatPercent = (value) => {
  if (value === null || value === undefined) return "N/A";
  return (value > 0 ? "+" : "") + (value * 100).toFixed(1) + "%";
};
